import '../assets/resources/custom/style/main-6.css'
import PageContent from '../components/util/PageContent'
import H1TitleId from '../components/title/H1TitleId'
import { Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { HcContext } from '../types/hccontext'
import GetStrLocalized from '../datas/GetStrLocalized'
import CategoriesBigButtons, { CategoryProps } from '../components/bigButton/CategoriesBigButtons'

interface HistoryProps {
    language: string;
    hcContext: HcContext;
}

function History({ language, hcContext }: Readonly<HistoryProps>) {

    useEffect(() => {
        hcContext.setDocumentTitle(GetStrLocalized(language, "history") + " - Holy Chatter");
    }, [language, hcContext])

	const categories: CategoryProps[] = [
        {nb: undefined, type: "", id: "", link: "/" + language + "/" + GetStrLocalized(language, "cmsFolderName") + "/" + GetStrLocalized(language, "historyFolderName") + "/" + GetStrLocalized(language, "chatHistoryFolderName"), image: "/categories/clock.jpg",
        duration: "", title: GetStrLocalized(language, "chatHistory"), subTitle: "", sourceName: "", sourceImage: "", stars: undefined },
        {nb: undefined, type: "", id: "", link: "/" + language + "/" + GetStrLocalized(language, "cmsFolderName") + "/" + GetStrLocalized(language, "historyFolderName") + "/" + GetStrLocalized(language, "contentEditHistoryFolderName"), image: "/categories/clock.jpg",
        duration: "", title: GetStrLocalized(language, "contentEditHistory"), subTitle: "", sourceName: "", sourceImage: "", stars: undefined }
   ]

    return (
        <PageContent>
            {
                !hcContext.userAsRightsToModifyTheContent &&
                <Navigate to={"/" + language} />
            }
            <H1TitleId language={language} titleId="history" />
            <br />
            <CategoriesBigButtons categories={categories} hcContext={hcContext} />
            <br />
        </PageContent>
    )
}

export default History
